import { useTypedSelector } from "hooks";
import { RoleName } from "consts/auth";
import { concat, when } from "util/support";
import { selectAuthUser } from "features/auth/selectors";

export const useUser = () => {
    const user = useTypedSelector(selectAuthUser);

    const getUserName = () => when(
        user,
        () => concat([user.firstName, user.lastName], { token: ' ' })
    );

    const hasRole = (roles: Array<RoleName>) =>
        roles.includes(user?.roleName);

    return {
        user,
        hasRole,
        getUserName
    };
};

export default useUser;
